import { render, staticRenderFns } from "./comparaison-quartiles.vue?vue&type=template&id=0fe120b2&scoped=true"
import script from "./comparaison-quartiles.vue?vue&type=script&lang=js"
export * from "./comparaison-quartiles.vue?vue&type=script&lang=js"
import style0 from "./comparaison-quartiles.vue?vue&type=style&index=0&id=0fe120b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe120b2",
  null
  
)

export default component.exports